import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ACTION_ERROR_TITLE } from '../../interceptors/http-error.interceptor';
import type {
  CreateWorkPosition,
  EditWorkPosition,
  WorkPosition,
} from '../../models/api/work-position.model';

@Injectable({
  providedIn: 'root',
})
export class WorkPositionService {
  private readonly httpClient = inject(HttpClient);
  private readonly positionApi = `${environment.apiUrl}/v1/codebooks/work-position`;

  getWorkPositions(): Observable<WorkPosition[]> {
    const context = new HttpContext().set(ACTION_ERROR_TITLE, 'Failed to Get Work Positions');
    return this.httpClient.get<WorkPosition[]>(`${this.positionApi}`, { context });
  }

  createWorkPosition(workPosition: CreateWorkPosition): Observable<WorkPosition> {
    const context = new HttpContext().set(ACTION_ERROR_TITLE, 'Failed to Create Work Position');

    return this.httpClient.post<WorkPosition>(this.positionApi, workPosition, { context });
  }

  editWorkPosition(id: number, workPosition: EditWorkPosition): Observable<WorkPosition> {
    const context = new HttpContext().set(ACTION_ERROR_TITLE, 'Failed to Edit Work Position');

    return this.httpClient.put<WorkPosition>(`${this.positionApi}/${id}`, workPosition, {
      context,
    });
  }

  deleteWorkPosition(id: number): Observable<void> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Delete Work Position. Please make sure there are no users associated with this work position',
    );

    return this.httpClient.delete<void>(`${this.positionApi}/${id}`, { context });
  }
}
